// TIK — Claude-editorial interactions
(function () {
  // Reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.tk-reveal').forEach(function (el) { io.observe(el); });

  // FAQ accordion
  document.querySelectorAll('.tk-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.tk-faq-item');
      var open = item.classList.contains('open');
      document.querySelectorAll('.tk-faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!open) item.classList.add('open');
    });
  });

  // Live clock in dark mockup
  var clock = document.querySelector('[data-tk-clock]');
  if (clock) {
    var tick = function () {
      var d = new Date();
      clock.textContent = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    };
    tick(); setInterval(tick, 15000);
  }

  // Add-to-cart: show adding state
  document.querySelectorAll('form[data-tk-atc]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var b = form.querySelector('button[type="submit"]');
      if (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Toevoegen…'; }
    });
  });

  // Smooth-scroll for same-page anchors
  document.querySelectorAll('a[href^="/#"], a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var hash = a.getAttribute('href').replace('/', '');
      var target = document.querySelector(hash);
      if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
})();
